<template>
  <div class="w-full h-full flex flex-col items-center bg-white overflow-auto">
    <div class="relative flex flex-col items-center justify-center" style="top: 12%">
      <div class="mb-4 text-large text-theme-black-850 font-semibold">推送报告</div>
      <p class="mb-6 text-medium text-theme-black-650 leading-22">答题人关注微信公众号，获取答题报告</p>
      <el-button type="primary" class="mb-8" @click="$emit('clickPush')">开启推送</el-button>
      <el-image
        :src="`${baseUrl}img/push_report_step.png`"
        class="max-w-full"
        style="width: 856px; height: 320px"
      ></el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PushReportInit'
}
</script>